import { useNavigate } from "react-router-dom";
import { StyledAppBar, StyledMagicBotLogo, StyledToolbar } from "../../../style/GlobalsComponentsStyled";
import { IconButton, Typography } from "@mui/material";

const NavBar = () => {
    const Navigate = useNavigate();

    const handleNavigation = (path: string) => {
        window.scrollTo({ top: 0 });
        Navigate(path);
    };

    return (
        <StyledAppBar>
            <StyledToolbar>
                <IconButton onClick={() => handleNavigation('/')} aria-label='go to home page'>
                    <StyledMagicBotLogo />
                </IconButton>
                <Typography variant="h1" sx={{ flexGrow: 1, textAlign: 'right' }} onClick={() => handleNavigation('/')}>
                    MagicBot
                </Typography>
            </StyledToolbar>
        </StyledAppBar>
    );
};

export default NavBar;
